export default __webpack_public_path__ + "e5b6ce6dd68de3fdda02a322e7a919d3.svg";